<template>
  <div v-if="item?.employee?.name">
    {{ item?.employee?.name }}
  </div>
  <div v-else>
    {{ item?.name }}
  </div>
</template>
<script>
export default {
  props: ["item"],
};
</script>
